import React, { useMemo } from 'react';

import {
  SidePage,
  IconButton,
  Card,
  CardHeader,
  CardContent,
  FileDownloadIcon,
  Stack,
} from '@gogame/components';
import { useMountedState } from '@gogame/hooks-ts';

import { useLoadCampaignDetails } from 'scenes/Campaigns/GGCampaigns/data';
import {
  useExportLinks,
  useGenerateLinks,
} from 'scenes/Campaigns/GGCampaigns/data/mutations';

import { TrackingLinksFilters } from './TrackingLinksFilters';
import { TrackingLinksList } from './TrackingLinksList';
import { FILTER_CONVERSION_PAGE_IDS } from './constants';

export const TrackingLinks = ({
  onClose,
  id,
  applicationId,
  networkId,
  onExited,
  open,
}) => {
  const { data: details } = useLoadCampaignDetails({ id });
  const [generateLinks, { data, isLoading }] = useGenerateLinks();
  const [exportLinks] = useExportLinks();
  const [formValues, setFormValues] = useMountedState(null);
  const handleSubmit = async (values) => {
    await loadData({
      [FILTER_CONVERSION_PAGE_IDS]: values[FILTER_CONVERSION_PAGE_IDS],
      id,
    });
    setFormValues(values);
  };

  const loadData = async (params) => {
    return generateLinks(params);
  };

  const handleExport = () => {
    exportLinks({
      [FILTER_CONVERSION_PAGE_IDS]: formValues[FILTER_CONVERSION_PAGE_IDS],
      id,
    });
  };

  const subTitle = useMemo(() => {
    return details ? `# ${details.id} / ${details.name}` : '';
  }, [details]);
  return (
    <SidePage
      backdrop={false}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading}
      open={open}
      size={'lg'}
    >
      <SidePage.Title title={'Generate Tracking Links'} subTitle={subTitle} />

      <SidePage.NewBody scroll={false}>
        <Stack spacing={3} direction={'column'}>
          <div>
            <TrackingLinksFilters
              onSubmit={handleSubmit}
              applicationId={applicationId}
              networkId={networkId}
            />
          </div>

          {data?.length ? (
            <Card elevation={6} flex={'1 0 auto'}>
              <CardHeader
                title={`Tracking Links (${data?.length || 0})`}
                action={
                  <IconButton
                    icon={<FileDownloadIcon />}
                    tooltip={'Export'}
                    onClick={handleExport}
                  />
                }
              />
              <CardContent>
                <TrackingLinksList width={'100%'} data={data} />
              </CardContent>
            </Card>
          ) : null}
        </Stack>
      </SidePage.NewBody>

      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
    </SidePage>
  );
};
